import React, { useEffect, useState } from 'react';
import classes from "./GamePage.module.css";
import { FaStarOfLife, FaChevronDown } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import {
    Autoplay,
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Keyboard,
    EffectCoverflow,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import {
    FaArrowRight, FaBars,
    FaXmark,
} from "react-icons/fa6";
import { fetchGamesApi } from '../http/http';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Loader from './Loader';

const GamePage = () => {

    const [loder, setloder] = useState(false);
    const [desktopGamesOpen, setDesktopGamesOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [mobileGamesOpen, setMobileGamesOpen] = useState(false);
    const [categories, setCategories] = useState([]);
    const [games, setGames] = useState([]);
    const [topGames, setTopGames] = useState([]);
    const [carousel, setCarousel] = useState([]);
    const navigate = useNavigate();
    const location=useLocation();

    const { id, name } = useParams();
 console.log("id==",id)

      const handleLogout = () => {
    // Remove the auth cookie by setting it to expire immediately
    localStorage.setItem("jwt",null)
    // document.cookie = "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    // Redirect the user to the home or login page
    window.location.href = "/login";
  };
   const fetchGames = async () => {
    try {
       setloder(false)

        const response = await fetchGamesApi();

        const allCategories = response?.data?.data?.categories || [];
        const allGames = response?.data?.data?.games || [];

        setCategories(allCategories);

        // ✅ create category with games (your existing logic)
        const categoryWithGames = allCategories.map(category => ({
            ...category,
            games: allGames.filter(game => game.category_id === category.id)
        }));

        // ✅ find selected category using URL param
        const selectedCategory = categoryWithGames.find(
            (cat) => String(cat.id) === String(id)
        );

        // ✅ set ONLY selected category games
        setGames(selectedCategory?.games || []);
        setloder(true)

        // top + carousel (keep as is)
        const randomGames = [...allGames]
            .sort(() => 0.5 - Math.random())
            .slice(0, 20);

        setTopGames(randomGames.slice(0, 5));
        setCarousel(randomGames);

    } catch (error) {
        console.log(error, "error in fetching games");
    }
};

    useEffect(() => {
        // if (location?.state?.gameid && location?.state?.gamecategory) {
            fetchGames();
        // }
        // else{
            // navigate('/');
        // }
    }, [location]);

    const handleNavigate = (url) => {
        window.location.href = url;
    }

    console.log(games, 'games---');

    return (
        <>
        {loder?
        <>
            {/* ================= HEADER ================= */}
                  <header className={classes.header}>
                          <nav className={classes.nav}>
                              <div className={classes.nav_items}>
          
                                  {/* Logo */}
                                  <div className={classes.logo_container} onClick={()=>{
                                    navigate('/')
                                  }}>
                                      <img
                                          src="/assets/images/logo.png"
                                          alt="logo"
                                          className={classes.logo}
                                      />
                                      <p className={classes.logo_text}>
                                          Game<span>Plex</span>
                                      </p>
                                  </div>
          
                                  {/* Desktop Menu */}
                                  <div className={classes.nav_items_data}>
                                      <button className={classes.nav_items_data_item} onClick={()=>{navigate('/')}}>Home</button>
          
                                      <div
                                          className={classes.dropdown_wrapper}
                                          onMouseEnter={() => setDesktopGamesOpen(true)}
                                          onMouseLeave={() => setDesktopGamesOpen(false)}
                                      >
                                          <button className={classes.nav_items_data_item}>
                                              Games
                                              <FaChevronDown
                                                  className={`${classes.chevron_icon} ${desktopGamesOpen ? classes.rotate : ""
                                                      }`}
                                              />
                                          </button>
          
                                          {desktopGamesOpen && (
                                              <div className={classes.dropdown_menu}>
                                                  {
                                                      categories.map((category) => (
                                                          <p key={category.id} className={classes.dropdown_item}
                                                              onClick={() => navigate(`/games/${category.id}/${category.category_name}`)}
                                                          >{category.category_name}</p>
                                                      ))
                                                  }
                                              </div>
                                          )}
                                      </div>
          
                                      {/* <button className={classes.nav_items_data_item}>
                                          Terms & Conditions
                                      </button> */}
          
                                      {/* <button className={classes.subscribe_button}
                                      onClick={hendelSub}
                                      >
                                          <span className={classes.star_icon_container}>
                                              <FaStarOfLife />
                                          </span>
                                          Subscribe
                                      </button> */}
                                  </div>
          
                                  {/* Desktop Avatar */}
                                  <button
                                      className={classes.logout_button}
                                      onClick={() => {
                                          // Optional: clear user session / token here
                                          localStorage.removeItem("userToken");
                                          handleLogout()
                                           // Redirect to login page
                                      }}
                                  >
                                      Logout
                                  </button>
          
                                  {/* Hamburger */}
                                  <button
                                      className={classes.hamburger}
                                      onClick={() => setMobileMenuOpen(true)}
                                      aria-label="Open menu"
                                  >
                                      <FaBars />
                                  </button>
                              </div>
                          </nav>
                      </header>
            <section className={classes.games_section}>
    <h2 className={classes.section_title}>
        {name} Games
    </h2>

    <div className={classes.games_grid}>
        {games.map((game) => (
            <div
                key={game.id}
                className={classes.game_card}
                onClick={() => handleNavigate(game.game_url)}
            >
                <img
                    src={game.game_banner}
                    alt={game.game_name}
                    className={classes.game_image}
                />
                <p className={classes.game_name}>
                    {game.game_name}
                </p>
            </div>
        ))}
    </div>
</section>

            {/* ================= OVERLAY ================= */}
            {mobileMenuOpen && (
                <div
                    className={classes.overlay}
                    onClick={() => {
                        setMobileMenuOpen(false);
                        setMobileGamesOpen(false);
                    }}
                />
            )}

            {/* ================= MOBILE DRAWER ================= */}
            <div
                className={`${classes.mobile_drawer} ${mobileMenuOpen ? classes.open : ""
                    }`}
            >
                <button
                    className={classes.close_btn}
                    onClick={() => {
                        setMobileMenuOpen(false);
                        setMobileGamesOpen(false);
                    }}
                    aria-label="Close menu"
                >
                    <FaXmark />
                </button>

                <button className={classes.drawer_item} onClick={()=>{
                    console.log("jijij")
                    navigate("/");
                    }}>Home</button>

                {/* Drawer Dropdown */}
                <div className={classes.drawer_dropdown}>
                    <button
                        className={classes.drawer_item}
                        onClick={() => setMobileGamesOpen(!mobileGamesOpen)}
                    >
                        Games
                        <FaChevronDown
                            className={`${classes.chevron_icon} ${mobileGamesOpen ? classes.rotate : ""
                                }`}
                        />
                    </button>

                    <div
                        className={`${classes.drawer_submenu} ${mobileGamesOpen ? classes.open : ""
                            }`}
                    >
                        {categories.map((category) => (
                            <p key={category.id} className={classes.drawer_subitem}
                                onClick={() => navigate(`/games/${category.id}/${category.category_name}`)}
                            >{category.category_name}</p>
                        ))}
                    </div>
                </div>

                {/* <button className={classes.drawer_item}>Terms & Conditions</button> */}

                <button className={classes.drawer_subscribe}>Subscribe</button>
            </div>


           {false && <section className={classes.hero_section}>
                <div className={classes.gradient_bg_1}></div>
                <div className={classes.gradient_bg_2}></div>
                <video autoPlay muted loop controls={false} className={classes.video_animation} >
                    <source src="/assets/video/hero_video.mp4" type="video/mp4" />
                </video>

                <div className={classes.hero_section_container}>
                    <div className={classes.hero_section_one}>
                        <div className={classes.title_section_one}>
                            {/* <span className={classes.title_small}>Play</span>
                            <span className={classes.title_small}>Earn</span>
                            <span className={classes.title_small}>Enjoy</span> */}

                            <button className={classes.back_button} onClick={()=>navigate(-1)}>
                                <FaChevronLeft className={classes.back_icon} />
                            </button>
                        </div>

                        <div className={classes.hero_section_two}>
                            <h1 className={classes.title_big}>
                                Ultimate
                            </h1>
                            <h1 className={classes.title_highlight}>
                                Gamer's
                            </h1>
                            <h1 className={classes.title_big}>
                                Haven
                            </h1>
                            <button type="button" className={classes.hero_play_button}>
                                Play Now
                            </button>
                        </div>

                    </div>

                    <div className={classes.hero_section_two}>
                        <img src="/assets/images/gradient.png" alt="gradient" className={classes.hero_section_two_image} />
                        <img src="/assets/images/player.png" alt="player" className={classes.player_image} />
                    </div>

                    <div className={classes.hero_section_three}>
                        <div className={classes.hero_section_three_container}>
                            <h3 className={classes.hero_section_three_heading}>Top Games</h3>

                            {topGames.map((game, idx) => (
                                <div className={classes.hero_section_three_game_container} key={idx}
                                    onClick={() => handleNavigate(game?.game_url)}
                                >
                                    <div className={classes.hero_section_three_game_image_container}>
                                        <img src={game?.game_banner} alt="game" className={classes.hero_section_three_game_image} />
                                    </div>
                                    <div className={classes.hero_section_three_content_container}>
                                        <p className={classes.hero_section_three_game_name}>{game?.game_name}</p>
                                        <p className={classes.hero_section_three_game_desc}>{game?.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {/* <div className={classes.cards_container}>
                                        <div className={classes.cards}>
                                            <img
                                                src={"/assets/images/game1.png"}
                                                className={classes.card}
                                                style={{ left: `10px` }}
                                                alt="avatar"
                                            />
                                            <img
                                                src={"/assets/images/game2.png"}
                                                className={classes.card}
                                                style={{ left: `20px` }}
                                                alt="avatar"
                                            />
                                            <img
                                                src={"/assets/images/game3.png"}
                                                className={classes.card}
                                                style={{ left: `30px` }}
                                                alt="avatar"
                                            />
                                            <div className={classes.badge} style={{ left: `40px` }}>
                                                99+
                                            </div>
                                        </div>
                                    </div>
                                    <div className={classes.label}>
                                        <span className={classes.dot} /> Games
                                    </div> */}
                    </div>
                </div>
            </section>}

            <footer className={classes.footer_container}>
                <div className={classes.footer_sub_container}>

                    {/* Logo + Links */}
                    <div className={classes.footer_grid}>
                        <div className={classes.logo_container2}>
                            <img
                                src="/assets/images/logo.png"
                                alt="GamePlex logo"
                                className={classes.logo}
                            />
                            <p className={classes.logo_text}>
                                Game<span>Plex</span>
                            </p>
                        </div>

                        <p className={classes.footer_link}>Home</p>
                        <p className={classes.footer_link}>Games</p>
                        {/* <p className={classes.footer_link}>Terms & Conditions</p> */}
                    </div>

                    {/* Categories */}
                    <div className={classes.footer_grid}>
                        <p className={classes.footer_heading}>Categories</p>
                        <p className={classes.footer_link}>Action</p>
                        <p className={classes.footer_link}>Adventure</p>
                        <p className={classes.footer_link}>Casual</p>
                    </div>

                </div>

                {/* Bottom bar */}
                <div className={classes.footer_bottom}>
                    © Bharat Tech Solutions LLP 2025
                </div>
            </footer>
        </>:<Loader/>}
        </>
    )
}

export default GamePage;

// const categories = [
//     { title: "Action", image: "/assets/images/game1.png" },
//     { title: "Racing", image: "/assets/images/game2.png" },
//     { title: "Puzzle", image: "/assets/images/game3.png" },
//     { title: "Adventure", image: "/assets/images/game4.png" },
//     { title: "Sports", image: "/assets/images/game5.png" },
//     { title: "Arcade", image: "/assets/images/game6.png" },
//     { title: "Kids", image: "/assets/images/game7.png" },
//     { title: "Multiplayer", image: "/assets/images/game5.png" }
// ];